<template>
  <v-app>
    <v-navigation-drawer
      floating
      permanent
      style="overflow:visible;"
      class="mr-12"
      dark
      color="white"
      app
    >
      <div class="rotate-drawer-bg primary"></div>
      <v-list-item class="mx-3 mt-3">
        <v-list-item-avatar tile width="75" height="75">
          <v-img src="logo.png"></v-img>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title class="title">
            {{ title }}
          </v-list-item-title>
          <v-list-item-subtitle>
            {{ subtitle }}
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-divider></v-divider>
      <v-list dense nav class="mx-3 mt-2">
        <v-list-item v-for="(item, key) in items.sets" :key="item.label" link>
          <v-list-item-content v-scroll-to="'#' + key">
            <v-list-item-title class="body-1">{{
              item.label
            }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <div class="logo">
        <a title="ZIGT" target="_blank" href="https://zigt.nl/wat-we-doen/creation-development"
          ><v-img src="zigt.png" aspect-ratio="1.7" contain></v-img
        ></a>
      </div>
    </v-navigation-drawer>
    <v-main>
      <v-container py-12 px-8>
        <div
          class="div mt-5"
          v-for="(item, key) in items.sets"
          :key="item.label"
        >
          <p :id="key" class="headline ml-5">{{ item.name }}</p>
          <v-divider class="mx-5 my-5"></v-divider>
          <v-row class="mx-5">
            <v-col md="auto" class="mb-8 fbcol" v-if="item.type === 'fb'">
              <v-lazy
                :options="{ threshold: 0.5 }"
                transition="fade-transition"
                class="relative"
              >
                <div class="fbcard">
                  <lazy-component tag="div" @loaded="handler">
                    <div class="top">
                      <img
                        :src="'sets/' + item.folder + '/' + item.icon"
                        alt="avatar"
                        class="avatar"
                      />
                      <div class="titleblock">
                        <div class="titlefb" v-html="item.pagina"></div>
                        <div class="sponserd">
                          <span>Gesponsord · </span>
                          <img src="@/assets/world.png" alt="world" />
                        </div>
                      </div>
                      <div class="menu">
                        <img src="@/assets/menu.png" alt="menu" />
                      </div>
                    </div>
                    <div class="message">
                      <div class="inner">
                        <p v-html="item.message"></p>
                      </div>
                    </div>
                    <div class="content">
                      <video
                        v-if="item.source_type === 'video'"
                        class="fbmp4"
                        controls
                        autoplay
                        muted
                        loop
                      >
                        <source
                          :src="'sets/' + item.folder + '/' + item.source"
                          type="video/mp4"
                        />
                      </video>
                    </div>
                    <a
                      :href="item.link"
                      target="_blank"
                      rel="noopener"
                      class="infofb"
                    >
                      <div class="left">
                        <div class="link" v-html="item.link_label"></div>
                        <div class="titleinfo" v-html="item.title"></div>
                        <div class="sub" v-html="item.sub"></div>
                      </div>
                      <div class="right">
                        <button class="buttonfb" v-html="item.button"></button>
                      </div>
                    </a>
                  </lazy-component>
                </div>
              </v-lazy>
            </v-col>
            <v-col md="auto" class="mb-12" v-else-if="item.type === 'mp3'">
              <audio controls>
                <source :src="'sets/' + item.folder + '/' + item.file + '.mp3'" type="audio/mpeg">
                Your browser does not support the audio element.
              </audio>
            </v-col>
            <v-col
              md="auto"
              class="mb-8"
              v-for="size in item.sizes"
              :key="size"
            >
              <p class="mb-1 grey--text text--darken-1">{{ size }}</p>
              <v-lazy
                :options="{ threshold: 0.5 }"
                transition="fade-transition"
                class="relative"
              >
                <v-card
                  :id="'id-' + size + '-' + item.folder + '-block'"
                  color="grey darken-3"
                  tile
                  class="mx-auto better-shadow relative"
                  :width="bannerWidth(size, item.scale)"
                  :height="bannerHeight(size, item.scale)"
                >
                  <v-progress-circular
                    indeterminate
                    color="white"
                    class="center-loading"
                  ></v-progress-circular>
                  <div>
                    <lazy-component tag="div" @loaded="handler">
                      <iframe
                        v-if="item.type === 'html'"
                        class="iframe"
                        :id="'id-' + size + '-' + item.folder"
                        :width="bannerWidth(size, item.scale)"
                        :height="bannerHeight(size, item.scale)"
                        frameborder="0"
                        :src="
                          'sets/' +
                            item.folder +
                            '/' +
                            size +
                            '/' +
                            size +
                            '.' +
                            item.type
                        "
                      ></iframe>
                      <video
                        v-else-if="item.type === 'mp4'"
                        class="mp4"
                        :id="'id-' + size + '-' + item.folder"
                        :width="bannerWidth(size, item.scale)"
                        :height="bannerHeight(size, item.scale)"
                        controls
                      >
                        <source
                          :src="
                            'sets/' +
                              item.folder +
                              '/' +
                              size +
                              '/' +
                              size +
                              '.' +
                              item.type
                          "
                          type="video/mp4"
                        />
                      </video>
                      <img
                        v-else-if="item.type === 'gif'"
                        :id="'id-' + size + '-' + item.folder"
                        class="iframe"
                        :width="bannerWidth(size, item.scale)"
                        :height="bannerHeight(size, item.scale)"
                        :src="
                          'sets/' +
                            item.folder +
                            '/' +
                            size +
                            '/' +
                            size +
                            '.' +
                            item.type
                        "
                      />
                      <img
                        v-else
                        :id="'id-' + size + '-' + item.folder"
                        class="iframe"
                        :width="bannerWidth(size, item.scale)"
                        :height="bannerHeight(size, item.scale)"
                        :src="
                          'sets/' +
                            item.folder +
                            '/' +
                            size +
                            '/' +
                            size +
                            '.' +
                            item.type
                        "
                      />
                    </lazy-component>
                  </div>
                  <div class="refresh">
                    <v-btn
                      v-if="item.type === 'html'"
                      v-on:click="reload(size, item.folder)"
                      text
                      icon
                      color="secondary"
                    >
                      <v-icon>mdi-cached</v-icon>
                    </v-btn>
                    <div v-else-if="item.type === 'mp4'"></div>
                    <v-btn
                      v-else-if="item.type === 'gif'"
                      v-on:click="
                        reloadImage(
                          size,
                          item.folder,
                          'sets/' +
                            item.folder +
                            '/' +
                            size +
                            '/' +
                            size +
                            '.' +
                            item.type
                        )
                      "
                      text
                      icon
                      color="secondary"
                    >
                      <v-icon>mdi-cached</v-icon>
                    </v-btn>
                    <div v-else></div>
                  </div>
                </v-card>
              </v-lazy>
            </v-col>
          </v-row>
        </div>
      </v-container>
    </v-main>
    <v-footer app color="accent" class="font-weight-medium">
      <v-col class="text-right white--text" cols="12">
        {{ new Date().getFullYear() }} — <strong>ZIGT</strong>
      </v-col>
    </v-footer>
  </v-app>
</template>

<script>
export default {
  name: "App",
  data: () => ({
    title: "",
    subtitle: "",
    items: []
  }),
  methods: {
    bannerWidth(size, scale) {
      if (scale) {
        const regex = /[0-9]+/g;
        const found = size.match(regex);
        return found[0];
      } else {
        const regex = /[0-9]+/g;
        const found = size.match(regex);
        return found[0] / 2;
      }
    },
    bannerHeight(size, scale) {
      if (scale) {
        const regex = /[0-9]+/g;
        const found = size.match(regex);
        return found[1];
      } else {
        const regex = /[0-9]+/g;
        const found = size.match(regex);
        return found[1] / 2;
      }
    },
    handler() {
      //console.log('loaded')
    },
    reload(size, folder) {
      document
        .getElementById("id-" + size + "-" + folder)
        .contentWindow.location.reload();
    },
    reloadImage(size, folder, src) {
      document.getElementById("id-" + size + "-" + folder).src =
        src + "?random=" + new Date().getTime();
    }
  },
  created() {
    this.title = this.$config.title;
    this.subtitle = this.$config.sub;
    this.items = this.$config;
  }
};
</script>

<style lang="scss">
#app {
  overflow: hidden;
}
.rotate-drawer-bg {
  position: absolute;
  width: calc(100% + 100vw);
  height: calc(100% + 100vw);
  top: -50vw;
  left: -100vw;
}
.refresh {
  position: absolute;
  left: 0;
  bottom: -2.6rem;
}
.relative {
  position: relative !important;
}
.center-loading {
  position: absolute !important;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.better-shadow {
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.11), 0 2px 2px rgba(0, 0, 0, 0.11),
    0 4px 4px rgba(0, 0, 0, 0.11), 0 6px 8px rgba(0, 0, 0, 0.11),
    0 8px 16px rgba(0, 0, 0, 0.11) !important;
}
.iframe {
  position: absolute;
  top: 0;
  left: 0;
}
.logo {
  z-index: 99;
  width: 7.5rem;
  position: absolute;
  left: 1.37rem;
  bottom: -3rem;
}
.mp4 {
  z-index: 2;
  position: relative;
}
.fbcol {
  background-color: #f0f2f5;
  width: calc(680px + (16px * 2));
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.fbcard {
  overflow: hidden;
  position: relative;
  width: 680px;
  border-radius: 6px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
  background-color: #ffffff;
  font-family: system-ui, -apple-system, BlinkMacSystemFont, ".SFNSText-Regular",
    sans-serif;
  .top {
    padding-top: 12px;
    margin-bottom: 12px;
    align-items: flex-start;
    display: flex;
    padding-right: 16px;
    padding-left: 16px;
    flex-direction: row;
    align-items: center;
    .avatar {
      width: 40px;
      height: 40px;
      border-radius: 80px;
      margin-right: 8px;
    }
    .titleblock {
      display: flex;
      flex-direction: column;
      margin-top: -5px;
      margin-bottom: -5px;
      flex-grow: 1;
      .titlefb {
        font-weight: 600;
        color: #050505;
        margin-bottom: 0px;
        margin-top: 5px;
        line-height: 1.2308;
      }
      .sponserd {
        margin-bottom: 5px;
        margin-top: 0px;
        line-height: 1.2308;
        span {
          font-size: 0.8125rem;
          color: #65676b;
        }
        img {
          position: relative;
          width: 12px;
          height: 12px;
          top: 1.25px;
          filter: invert(39%) sepia(21%) saturate(200%) saturate(109.5%)
            hue-rotate(174deg) brightness(94%) contrast(86%);
        }
      }
    }
    .menu {
      width: 20px;
      height: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 8px;
      img {
        width: 16px;
        height: 16px;
        filter: invert(39%) sepia(21%) saturate(200%) saturate(109.5%)
          hue-rotate(174deg) brightness(94%) contrast(86%);
      }
    }
  }
  .message {
    padding-bottom: 5px;
    padding-right: 16px;
    padding-left: 16px;
    padding-top: 5px;
    .inner {
      margin-top: -8px;
      margin-bottom: -8px;
      display: flex;
      flex-direction: column;
      p {
        font-size: 0.9375rem;
        line-height: 1.3333;
      }
    }
  }
  .content {
    position: relative;
    .fbmp4 {
      width: 680px;
      height: 680px;
      object-fit: cover;
      background-color: #000;
      border-top: #e2e2e4 1px solid;
      box-shadow: 0 1px 0 0 rgba(0, 0, 0, 0.5);
    }
  }
  .infofb {
    position: relative;
    margin-top: -5px;
    background-color: #f0f2f5;
    padding-top: 10px;
    margin-bottom: 10px;
    align-items: flex-start;
    display: flex;
    padding-right: 16px;
    padding-left: 16px;
    flex-direction: row;
    align-items: center;
    border-bottom: #c8cace 1px solid;
    text-decoration: none;
    .left {
      flex-grow: 1;
      .link {
        position: relative;
        font-size: 0.8125rem;
        line-height: 1.2308;
        color: #65676b;
        text-transform: uppercase;
        display: block;
      }
      .titleinfo {
        position: relative;
        margin-top: 2px;
        display: block;
        font-weight: 600;
        font-size: 1.0625rem;
        color: #050505;
        margin-bottom: -1px;
      }
      .sub {
        position: relative;
        display: block;
        font-size: 0.9375rem;
        line-height: 1.3333;
        color: #65676b;
        margin-bottom: 8px;
      }
    }
    .right {
      .buttonfb {
        top: -6px;
        transition: background-color .15s ease-in-out;
        position: relative;
        background-color: #e4e6eb;
        height: 36px;
        padding-left: 12px;
        padding-right: 12px;
        display: flex;
        justify-content: center;
        flex-direction: row;
        align-items: center;
        flex-wrap: nowrap;
        border-radius: 6px;
        font-weight: 600;
            font-size: .9375rem;
                line-height: 1.3333;
                color: #050505;
        &:hover {
          background-color: rgba(0, 0, 0, 0.15);
          }
      }
    }
  }
}
</style>
